export default __webpack_public_path__ + "static/media/credit-lock.e7579cd0.svg";